<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="招聘专员" prop="topUserId" >
        <a-select v-model="form.topUserId" property="请选择" optionFilterProp="children" showSearch>
          <a-select-option v-for="(topUser,index) in topUserList" :key="index" :value="topUser.id">{{ topUser.nickname + ' (' + topUser.mobile + ')' }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import { clientMigration , pageTopUser } from '@/api/biz/user'

export default {
  name: 'SetStatusForm',
  props: {
  },
  components: {

  },
  data () {
    return {
      uploading: false,
      submitLoading: false,
      formTitle: '',
      fileList: [],
      fields: [],
      topUserList: [],
      ids: null,
      fieldIndex: null,
      // 表单参数
      form: {
        ids: null,
        topUserId: null,
        remark: null
      },
      queryParam: {
        pageNum: 1,
        pageSize: 1000
      },
      formType: 1,
      open: false,
      name: '',
      rules: {
        topUserId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.fileList = []
      this.ids = null
      this.form = {
        ids: null,
        topUserId: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (ids) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '设置状态'
      debugger
      this.form.ids = ids.join(',')
      this.queryTopUser()
    },
    queryTopUser() {
      pageTopUser(this.queryParam).then(response => {
        this.topUserList = response.data.records
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          clientMigration(this.form).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  thead {
    tr {
      th {
        padding: 6px 8px;
        color: #000;
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 12px 8px;
        color: #000;
        text-align: left;
        background: #fff;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease;
        word-break: break-word;
        line-height: 18px;
      }
    }
  }
}
</style>
